/**
 * 本文件用于修改blockly块的xml档加载和产出，以适应与app端产生xml档的差异
 */
const Blockly = window.Blockly;
const joints =  "body_head_sagittal_new,body_head_horizontal_new,body_shoulder_left_horizontal,body_shoulder_left_sagittal,body_shoulder_left_frontal,body_elbow_left_sagittal,body_shoulder_right_horizontal,body_shoulder_right_sagittal,body_shoulder_right_frontal,body_elbow_right_sagittal";
function getBlockChild(block, query){
    let result = block.querySelector(query);
    if(result && result.parentNode === block){
        return result;
    }
    return null;
}
function appendBeforeNext(parent, node){
    let next = getBlockChild(parent, "next");
    if(next){
        parent.insertBefore(node, next);
    } else {
        parent.appendChild(node);
    }
}
export default function(){
    //修正xml档输入输出，为了能适配app端产生的xml档
    (function fixXmlInputAndOutput(){
        //输入
        Blockly.Xml.utils.textToDomDocument=function(text){
            var xml = (new DOMParser).parseFromString(text,"text/xml");
            //start_when_v2
            xml.querySelectorAll("block[type='start_when_v2']").forEach(block => {
                var statementBlock,nextBlock;
                statementBlock = getBlockChild(block, "statement[name='do1']");
                if(statementBlock){
                    nextBlock = document.createElement("next");
                    nextBlock.innerHTML = statementBlock.innerHTML;
                    block.removeChild(statementBlock);
                    block.appendChild(nextBlock);
                }
            });

            //drive_turn_v1/drive_ward_v1/
            xml.querySelectorAll("block[type='drive_turn_v1'],block[type='drive_ward_v1']").forEach(block => {
                var input1 = getBlockChild(block, "field[name='input1']"),
                input2 = getBlockChild(block, "field[name='input2']"),
                input3 = getBlockChild(block, "field[name='input3']"),
                text;
                if(input1 && !input2 && !input3){
                    block.removeChild(input1);
                    text = input1.textContent;
                    text = text.split(",");
                    input1.textContent = text[0];//方向
                    input2 = document.createElement("field");
                    input2.setAttribute("name", "input2");
                    input2.textContent = text[2];//速度
                    input3 = document.createElement("field");
                    input3.setAttribute("name", "input3");
                    input3.textContent = text[1] || 0;//角度/距离
                    appendBeforeNext(block, input1);
                    appendBeforeNext(block, input2);
                    appendBeforeNext(block, input3);
                }
            });

            //關節塊
            let allJoints = joints.split(",").map(item => {
                return "block[type='" + item + "']";
            });
            allJoints = allJoints.join(",");
            xml.querySelectorAll(allJoints).forEach(block => {
                var input1 = getBlockChild(block, "field[name='input1']"),
                input2 = getBlockChild(block, "field[name='input2']"),
                text;
                if(input1 && !input2){
                    text = input1.textContent;
                    text = text.split(",");
                    var inputValue2;
                    var inputValue1;
                    if(text.length === 4){
                        //新版有速度
                        inputValue2 = text.pop();
                        inputValue1 = text.join(",");
                    } else if(text.length === 3){
                        //老版沒有速度
                        inputValue1 = text.join(",");
                        inputValue2 = "1";
                    }
                    block.removeChild(input1);
                    input1.textContent = inputValue1;
                    input2 = document.createElement("field");//id，方向，角度
                    input2.setAttribute("name", "input2");//速度
                    input2.textContent = inputValue2;
                    appendBeforeNext(block, input1);
                    appendBeforeNext(block, input2);
                }
            });

            //start_call_function -> procedures_callnoreturn
            xml.querySelectorAll("block[type='start_call_function']").forEach(block => {
                block.setAttribute("type", "procedures_callnoreturn");
                let nameField = getBlockChild(block, "field[name='input1']");
                if(nameField && nameField.parentNode === block){
                    let funcName = nameField.textContent;
                    let mutation = document.createElement("mutation");
                    mutation.setAttribute("name", funcName);
                    block.insertBefore(mutation, nameField);
                    block.removeChild(nameField);
                }
            });
            //start_function -> procedures_defnoreturn
            xml.querySelectorAll("block[type='start_function']").forEach(block => {
                block.setAttribute("type", "procedures_defnoreturn");
                let nameField = getBlockChild(block, "field[name='input1']");
                if(nameField && nameField.parentNode === block){
                    nameField.setAttribute("name", "NAME");
                }
                let statement = getBlockChild(block, "statement[name='function']");
                if(statement && statement.parentNode === block){
                    statement.setAttribute("name", "STACK");
                }
            });
            //nuwa_rotate_joint
            xml.querySelectorAll("block[type='nuwa_rotate_joint']").forEach(block => {
                let input3 = getBlockChild(block, "value[name='input3']");
                let input4 = getBlockChild(block, "field[name='input4']");
                if(!input4){
                    input4 = document.createElement("field");
                    input4.setAttribute("name", "input4");
                    if(input3){
                        block.insertBefore(input4, input3);
                    }
                }
            });
            //start_when_recognize
            xml.querySelectorAll("block[type='start_when_recognize']").forEach(block => {
                let do1 = getBlockChild(block, "statement[name='do1']")
                if(do1){
                    let next = document.createElement('next')
                    next.innerHTML = do1.innerHTML
                    block.removeChild(do1)
                    block.appendChild(next)
                }
            })
            // sound_say tts+隨機動作
            xml.querySelectorAll("block[type='sound_say']").forEach(block => {
                let input1 = getBlockChild(block, "field[name='input1']");
                let input2 = document.createElement('field')
                input2.setAttribute("name", "input2")
                if(input1){
                    let content = input1.textContent
                    let matches = content.match(/^(.+)\,(0|1)$/)
                    if(matches){
                        input1.textContent = matches[1]
                        input2.textContent = matches[2]
                    } else {
                        input2.textContent = '0'
                    }
                    appendBeforeNext(block, input2)
                }
            })
            return xml;
        };
        //输出
        Blockly.Xml.utils.domToText=function(xml){
            //start_when_v2
            xml.querySelectorAll("block[type='start_when_v2']").forEach(block => {
                var statementBlock,nextBlock;
                statementBlock = getBlockChild(block, "statement[name='do1']");
                nextBlock = getBlockChild(block, "next");
                if(nextBlock){
                    statementBlock = document.createElement("statement");
                    statementBlock.setAttribute("name", "do1");
                    statementBlock.innerHTML = nextBlock.innerHTML;
                    block.removeChild(nextBlock);
                    block.appendChild(statementBlock);
                }
            });

            //drive_turn_v1/drive_ward_v1/
            xml.querySelectorAll("block[type='drive_turn_v1'],block[type='drive_ward_v1']").forEach(block => {
                var input1 = getBlockChild(block, "field[name='input1']"),
                input2 = getBlockChild(block, "field[name='input2']"),
                input3 = getBlockChild(block, "field[name='input3']");
                if(input1 && input2 && input3){
                    var value1 = input1.textContent;//方向
                    var value2 = input2.textContent || "1";//速度
                    var value3 = input3.textContent || 0;//角度/距离
                    block.removeChild(input1);
                    block.removeChild(input2);
                    block.removeChild(input3)
                    input1.textContent = [value1, value3, value2].join(",");
                    appendBeforeNext(block, input1);
                }
            });

            //關節塊
            let allJoints = joints.split(",").map(item => {
                return "block[type='" + item + "']";
            });
            allJoints = allJoints.join(",");
            xml.querySelectorAll(allJoints).forEach(block => {
                var input1 = getBlockChild(block, "field[name='input1']"),
                input2 = getBlockChild(block, "field[name='input2']");
                if(input1 && input2){
                    var value1 = input1.textContent;
                    var value2 = input2.textContent;
                    block.removeChild(input1);//id，方向，角度
                    block.removeChild(input2);//速度
                    input1.textContent = [value1, value2].join(",");
                    appendBeforeNext(block, input1);
                }
            });

            //  procedures_callnoreturn -> start_call_function
            xml.querySelectorAll("block[type='procedures_callnoreturn']").forEach(block => {
                block.setAttribute("type", "start_call_function");
                let nameMutation = getBlockChild(block, "mutation");
                if(nameMutation && nameMutation.parentNode === block){
                    let funcName = nameMutation.getAttribute("name");
                    let nameField = document.createElement("field");
                    nameField.setAttribute("name", "input1");
                    nameField.textContent = funcName;
                    block.insertBefore(nameField, nameMutation);
                    block.removeChild(nameMutation);
                }
            });

            //  procedures_defnoreturn -> start_function
            xml.querySelectorAll("block[type='procedures_defnoreturn']").forEach(block => {
                block.setAttribute("type", "start_function");
                let nameField = getBlockChild(block, "field[name='NAME']");
                if(nameField && nameField.parentNode === block){
                    nameField.setAttribute("name", "input1");
                }
                let statement = getBlockChild(block, "statement[name='STACK']");
                if(statement && statement.parentNode === block){
                    statement.setAttribute("name", "function");
                }
                // 移出函数描述，但移出了函数的描述不能被保存，不移除又怕在机器人执行会有错，好鸡儿纠结
                // let comment = getBlockChild(block, "comment");
                // if(comment && comment.parentNode === block){
                //     block.removeChild(comment);
                // }
            });
            //nuwa_rotate_joint
            xml.querySelectorAll("block[type='nuwa_rotate_joint']").forEach(block => {
                let input4 = getBlockChild(block, "field[name='input4']");
                if(input4 && input4.parentNode === block){
                    block.removeChild(input4);
                }
            });
            //start_when_recognize
            xml.querySelectorAll("block[type='start_when_recognize']").forEach(block => {
                let next = getBlockChild(block, 'next')
                if(next){
                    let do1 = document.createElement('statement')
                    do1.setAttribute('name', 'do1')
                    do1.innerHTML = next.innerHTML
                    block.removeChild(next)
                    block.appendChild(do1)
                }
            })
            // sound_say tts+隨機動作
            xml.querySelectorAll("block[type='sound_say']").forEach(block => {
                let input1 = getBlockChild(block, "field[name='input1']");
                let input2 = getBlockChild(block, "field[name='input2']");
                if(input1 && input2){
                    let content = input1.textContent
                    let randomMotion = input2.textContent
                    input1.textContent = `${content},${randomMotion}`
                    block.removeChild(input2)
                }
            })
            return(new XMLSerializer).serializeToString(xml).replace(/\'/g, "\\\'");
        };
    })();
}